/* eslint-disable no-restricted-imports */
import {
  IconButton,
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
  DialogTitle as MUIDialogTitle,
  styled,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export const Dialog = MUIDialog;
export const DialogActions = MUIDialogActions;
export const DialogContent = MUIDialogContent;
export const DialogTitle = MUIDialogTitle;

export const DialogHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      {onClose && (
        <IconButton variant="contained" color={"secondary"} size={"tiny"} onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      )}
    </div>
  );
})({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  padding: "24px 24px 0 24px",
  marginBottom: "-8px",
});
